import BioTab from "./BioTab";

export default BioTab;
